import { Component } from 'react';

// Available Languages
import availableLanguagesData from './availableLanguages.json'

// Languages
import en from './locales/en.json'
import de from './locales/de.json'

// Router
import {
  withRouter
} from 'react-router-dom'

class Lang extends Component {

  static getLanguageFromUrl = (lang) => {
    switch (lang) {
      case "/en":
        return "EN"
      default:
        return "DE"
    }
  }
  
  static translate(string, lang, stringToReplace){
    const stringSplit = string.split(':')
    const key = stringSplit[0]
    const name = stringSplit[1]
    const loadedLocale = this.getLanguageFromUrl(lang)
  
    var localeStringsToLoad = de
    switch (loadedLocale) {
      case "EN":
        localeStringsToLoad = en
        break;
      default:
        localeStringsToLoad = de
        break;
    }
    try{
      if(name !== null && stringSplit.length > 0 && typeof stringSplit !== 'undefined' && typeof localeStringsToLoad !== 'undefined'){
        var returnedString = localeStringsToLoad[key][name]
        if(returnedString !== undefined && returnedString !== null && typeof returnedString !== 'undefined'){
          return returnedString
        }
        else if(localeStringsToLoad !== de){
          returnedString = de[key][name]
          if(returnedString !== undefined && returnedString !== null){
            return returnedString
          }
          else{
            return string
          }
        }
      }
      else{
        return string
      }
    }
    catch(error){
      console.log(error)
      return string
    }
  }
  
  static availableLanguages(){
    return availableLanguagesData.map((value) => {
      const languageObject = {
        id: value.id,
        code: value.languageISO,
        displayString: value.languageDisplay
      }
      return languageObject
    })
  }
}

export default withRouter(Lang);


// WEBPACK FOOTER //
// ./src/i18n/index.js